import { render, staticRenderFns } from "./gaowei.vue?vue&type=template&id=51ad022a"
import script from "./gaowei.vue?vue&type=script&lang=js"
export * from "./gaowei.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports